export default __webpack_public_path__ + "static/media/culture-cruncher.0b85e5d3.png";